// Client-side mirror of the backend conditional-visibility engine.
function num(v) {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
}

export function isVisible(question, answers) {
  const conds = question.conditions || [];
  if (!conds.length) return true;
  const logic = question.condition_logic || "all";
  const results = conds.map((c) => {
    const target = answers[c.question_id];
    switch (c.operator) {
      case "equals": return String(target) === String(c.value);
      case "not_equals": return String(target) !== String(c.value);
      case "includes": return Array.isArray(target) && target.includes(c.value);
      case "greater_than": return num(target) > num(c.value);
      case "less_than": return num(target) < num(c.value);
      default: return true;
    }
  });
  return logic === "all" ? results.every(Boolean) : results.some(Boolean);
}

export function visibleQuestions(questions, answers) {
  return (questions || [])
    .filter((q) => q.active !== false && isVisible(q, answers))
    .sort((a, b) => a.order - b.order);
}

export function isAnswered(question, answers) {
  const v = answers[question.id];
  if (!question.required) return true;
  if (v === undefined || v === null || v === "") return false;
  if (Array.isArray(v) && v.length === 0) return false;
  return true;
}
